{
 "male": [
  "Aelar",
  "Thalion",
  "Faelan",
  "Eryndor",
  "Caelith",
  "Varis",
  "Soren",
  "Adran",
  "Aelrindel",
  "Aerdan",
  "Ahvain",
  "Aramil",
  "Arannis",
  "Aust",
  "Azaki",
  "Beiro",
  "Berrian",
  "Caeldrim",
  "Carric",
  "Dayereth",
  "Dreali",
  "Efferil",
  "Eiravel",
  "Enialis",
  "Erdan",
  "Erevan",
  "Fivin",
  "Galinndan",
  "Gennal",
  "Hadarai",
  "Halimath",
  "Heian",
  "Himo",
  "Immeral",
  "Ivellios",
  "Korfel",
  "Lamlis",
  "Laucian",
  "Lucan",
  "Mindartis",
  "Naal",
  "Nutae",
  "Paelias",
  "Peren",
  "Quarion",
  "Riardon",
  "Rolen",
  "Silvyr",
  "Suhnae",
  "Thamior",
  "Theren",
  "Theriatis",
  "Thervan",
  "Uthemar",
  "Vanuath",
  "Elrohir",
  "Beleg",
  "Mablung",
  "Gwindor",
  "Glorfindel",
  "Celeborn",
  "Haldir",
  "Orophin",
  "Rumil",
  "Lindir",
  "Erestor",
  "Gildor",
  "Cirdan",
  "Amroth",
  "Ecthelion",
  "Egalmoth",
  "Penlod",
  "Duilin",
  "Salgant",
  "Voronwe",
  "Ingwion",
  "Finrod",
  "Orodreth",
  "Angrod",
  "Aegnor",
  "Edrahil",
  "Gelmir",
  "Arminas",
  "Saeros",
  "Daeron",
  "Mahtan",
  "Elladan",
  "Thranduil",
  "Amdir",
  "Oropher",
  "Galion",
  "Feren",
  "Taurion",
  "Elros",
  "Annael",
  "Curufin",
  "Ithilden",
  "Jiriki",
  "Ineluki",
  "Khendraja",
  "Sijandi",
  "Kendrae",
  "Yizashi",
  "Hakatri",
  "Rhaenor",
  "Ilphas",
  "Talathel",
  "Aerendyl",
  "Cyrdemac",
  "Elaith",
  "Fenris",
  "Ilbryn",
  "Kerym",
  "Lafarallin",
  "Melarue",
  "Nym",
  "Orlpar",
  "Rathal",
  "Sarya",
  "Tarathiel",
  "Uevareth",
  "Vamir",
  "Vulmon",
  "Yhendorn",
  "Zaltarish",
  "Aldon",
  "Belanor",
  "Cathal",
  "Dairon",
  "Elrandir",
  "Faeron",
  "Galaeron",
  "Hagan",
  "Iliphar",
  "Jandar",
  "Kelvhan",
  "Leodor",
  "Myriil",
  "Nelaeryn",
  "Olodan",
  "Paeral",
  "Quilon",
  "Rennyn",
  "Saelihn",
  "Taeral",
  "Unnar",
  "Vharun",
  "Wylrin",
  "Yesanith",
  "Zandilar",
  "Mithrandel",
  "Anomen",
  "Kieran",
  "Zevran",
  "Fenarel",
  "Tamlen",
  "Ilen",
  "Haren",
  "Mahanon",
  "Dirthamen",
  "Elgar'nan",
  "Falon'din",
  "Ghilan",
  "Thalor",
  "Lirien",
  "Aerlinn",
  "Calenmir",
  "Dorlas",
  "Elendur",
  "Faramin",
  "Galdor",
  "Hirgon",
  "Iorlas",
  "Lathron",
  "Malbeth",
  "Nimloth",
  "Orleg",
  "Pelendur",
  "Rhovan",
  "Thorondir",
  "Ulmion",
  "Vardamir",
  "Arcamenel",
  "Ciryon",
  "Elemmir",
  "Fingon",
  "Istuion",
  "Laurendil",
  "Mornel",
  "Nolofin",
  "Oromir",
  "Pengolodh",
  "Quennar",
  "Rúmil",
  "Sarnion",
  "Tavaril",
  "Umbarin",
  "Valandil",
  "Yavion",
  "Brannoch",
  "Caerwyn",
  "Eirian",
  "Gwion",
  "Lleu",
  "Nuadha",
  "Oisin",
  "Penwyn",
  "Taliesin",
  "Aonghas",
  "Bran",
  "Cathair",
  "Diarmuid",
  "Eochaid",
  "Fionn",
  "Lir",
  "Midir",
  "Ailill",
  "Amarth",
  "Belthil",
  "Celegorm",
  "Daeros",
  "Edhellas",
  "Faelion",
  "Galathil",
  "Hallas",
  "Lenwe",
  "Luinil",
  "Maeglin",
  "Rochion",
  "Saelon",
  "Tauron",
  "Ulwarth",
  "Aethis",
  "Briareth",
  "Calithil",
  "Dinendal",
  "Elvathir",
  "Fennoril",
  "Gelvaris",
  "Hethion",
  "Ilmaris",
  "Juniel",
  "Keleth",
  "Loravar",
  "Maelis",
  "Naevor",
  "Orrien",
  "Quessin",
  "Seravin",
  "Tirion",
  "Ulvaris",
  "Veyron",
  "Wyndel",
  "Xilvar",
  "Yaerith",
  "Zephiel",
  "Anaxis",
  "Silchas",
  "Andarist",
  "Orfantal",
  "Endest",
  "Spinnock",
  "Nimander",
  "Skintick",
  "Andaris",
  "Sethis",
  "Nalderon",
  "Kaelor",
  "Thaeron",
  "Vaelin",
  "Iorveth",
  "Avallach",
  "Eredin",
  "Caranthir",
  "Imlerith",
  "Aelirenn",
  "Riordan",
  "Oriel",
  "Eltharin",
  "Maedhros",
  "Aerion",
  "Belvorn",
  "Caladrel",
  "Durothil",
  "Folas",
  "Galan",
  "Ilyrin",
  "Nueleth",
  "Orist",
  "Rilitar",
  "Syndrel",
  "Tasarion",
  "Ualair",
  "Ruvaen",
  "Selorn",
  "Imizael",
  "Aravilar",
  "Haldreth",
  "Halueth",
  "Ithrin"
 ],
 "female": [
  "Ilyana",
  "Sylvara",
  "Lirael",
  "Naeris",
  "Aerin",
  "Elowen",
  "Mirien",
  "Adrie",
  "Althaea",
  "Andraste",
  "Antinua",
  "Bethrynna",
  "Birel",
  "Caelynn",
  "Drusilia",
  "Enna",
  "Felosial",
  "Ielenia",
  "Jelenneth",
  "Keyleth",
  "Leshanna",
  "Lia",
  "Meriele",
  "Mialee",
  "Naivara",
  "Quelenna",
  "Quillathe",
  "Sariel",
  "Shanairra",
  "Shava",
  "Silaqui",
  "Theirastra",
  "Thia",
  "Vadania",
  "Valanthe",
  "Xanaphia",
  "Idril",
  "Galadwen",
  "Nimrodel",
  "Elwing",
  "Nellas",
  "Mithrellas",
  "Earwen",
  "Anaire",
  "Finduilas",
  "Aredhel",
  "Nerdanel",
  "Indis",
  "Miriel",
  "Elenwe",
  "Celebrian",
  "Amarie",
  "Nienna",
  "Uinen",
  "Nessa",
  "Ithilwen",
  "Tinuviel",
  "Melian",
  "Lothiriel",
  "Hiswen",
  "Elanor",
  "Niniel",
  "Aerwen",
  "Amerasu",
  "Likimeya",
  "Aditu",
  "Simi",
  "Imaru",
  "Zinjadu",
  "Shiyuni",
  "Khendra",
  "Senditu",
  "Merrill",
  "Velanna",
  "Lanaya",
  "Ashalle",
  "Ariane",
  "Sarethia",
  "Elora",
  "Ithelas",
  "Taarlath",
  "Isaia",
  "Valendrian",
  "Mihris",
  "Ilaria",
  "Marethari",
  "Sylaise",
  "Andruil",
  "Elathra",
  "Nerys",
  "Korlat",
  "Aranatha",
  "Desra",
  "Phaed",
  "Silanah",
  "Sandalath",
  "Enesdia",
  "Hish",
  "Menandore",
  "Sheltatha",
  "Sukul",
  "Velisa",
  "Lyandra",
  "Alustriel",
  "Qilue",
  "Sylune",
  "Laeral",
  "Amlaruil",
  "Ilsevele",
  "Saida",
  "Larelle",
  "Ecaeris",
  "Faeryl",
  "Hachaene",
  "Naertha",
  "Talindra",
  "Yathlanae",
  "Caerthynna",
  "Daratrine",
  "Ecthiliel",
  "Faunalyn",
  "Gaelira",
  "Haela",
  "Imrelle",
  "Jhessail",
  "Kythaela",
  "Laerune",
  "Maelyra",
  "Nathaliel",
  "Olowyn",
  "Phaerelle",
  "Rhaenya",
  "Saelvia",
  "Tasarel",
  "Ulathrae",
  "Vaelith",
  "Wynnalae",
  "Yrlissa",
  "Zaelyn",
  "Aeriel",
  "Briallen",
  "Celyndra",
  "Daenara",
  "Elaris",
  "Fenna",
  "Gwynira",
  "Halaeth",
  "Irethiel",
  "Jaelle",
  "Kaelira",
  "Lunavel",
  "Myrrhine",
  "Nualenna",
  "Pellessa",
  "Quiriel",
  "Rielle",
  "Tauriel",
  "Wyrenna",
  "Yelleth",
  "Aelinor",
  "Bellethiel",
  "Calariel",
  "Dinaeth",
  "Faelwen",
  "Galethra",
  "Hiraethiel",
  "Ilmarien",
  "Juliel",
  "Lindariel",
  "Melethiel",
  "Nimwen",
  "Orwen",
  "Pelaria",
  "Quessa",
  "Rilynn",
  "Selendra",
  "Thalindra",
  "Ulaithe",
  "Valariel",
  "Wyndra",
  "Aerona",
  "Rhiannon",
  "Niamh",
  "Etain",
  "Fand",
  "Sinann",
  "Clíodhna",
  "Liriel",
  "Aelira",
  "Caelia",
  "Dariel",
  "Elarwen",
  "Feanna",
  "Galathiel",
  "Helanwe",
  "Ilanor",
  "Joriel",
  "Kaeleth",
  "Lilaeth",
  "Maelin",
  "Naelia",
  "Oressa",
  "Philaeth",
  "Ravalyn",
  "Saelune",
  "Tirelle",
  "Uvalia",
  "Veriel",
  "Wilanya",
  "Yavanne",
  "Amaranthe",
  "Belisane",
  "Cirien",
  "Fiora",
  "Gilraen",
  "Hesperel",
  "Islanzadi",
  "Ondine",
  "Perenna",
  "Rowaniel",
  "Silmeria",
  "Tamsiel",
  "Unariel",
  "Vesperin",
  "Windriel",
  "Asteria",
  "Brisane",
  "Calithra",
  "Evanthe",
  "Faerith",
  "Glenwyn",
  "Halia",
  "Ivyra",
  "Jynara",
  "Kirasol",
  "Lysandra",
  "Mirelle",
  "Nephele",
  "Peridwen",
  "Raelith",
  "Ulyra",
  "Viriel",
  "Ashariel",
  "Brethiel",
  "Calaelen",
  "Cyrenna",
  "Daelyra",
  "Elandra",
  "Elessa",
  "Erethiel",
  "Faelora",
  "Filauria",
  "Galaena",
  "Gwaelin",
  "Haldalyn",
  "Ilvanna",
  "Ithriel",
  "Jhalara",
  "Kethrys",
  "Laeriel",
  "Lyrielle",
  "Maethe",
  "Merethyl",
  "Naeryn",
  "Nithriel",
  "Olaeth",
  "Pelyra",
  "Quinsiel",
  "Rhaelys",
  "Rynaria",
  "Saphiel",
  "Shaerl",
  "Sylmae",
  "Tanuviel",
  "Thaessa",
  "Ulmira",
  "Vaenya",
  "Valaena",
  "Vylwen",
  "Yaeliss",
  "Ysmaril",
  "Zaphyra",
  "Alathene",
  "Amnestria",
  "Chandrelle",
  "Dessaril",
  "Eldaena",
  "Feyrith",
  "Ghiraele",
  "Ilphaera",
  "Ilrune",
  "Maiele",
  "Naevys",
  "Shalana",
  "Syndra",
  "Tsaena",
  "Ysiliel",
  "Aewin",
  "Caladwen",
  "Elendira"
 ],
 "family": [
  "Moonwhisper",
  "Silverleaf",
  "Starbloom",
  "Dawnsong",
  "Nightbreeze",
  "Willowmere",
  "Amberglade",
  "Sunfall",
  "Mistwalker",
  "Greenmantle",
  "Amakiir",
  "Galanodel",
  "Liadon",
  "Holimion",
  "Ilphelkiir",
  "Meliamne",
  "Nailo",
  "Siannodel",
  "Xiloscient",
  "Amastacia",
  "Brightwood",
  "Evenwood",
  "Goldpetal",
  "Gemblossom",
  "Moonflower",
  "Starflower",
  "Oakenheel",
  "Windrivver",
  "Alenuath",
  "Alevenor",
  "Aloevan",
  "Amaratharr",
  "Amarzian",
  "Ammath",
  "Anuvien",
  "Arnth",
  "Auvryndar",
  "Berethryl",
  "Brightsong",
  "Caerdaen",
  "Calauth",
  "Cathdeiryn",
  "Celorn",
  "Crysalbar",
  "Dahast",
  "Dalhrae",
  "Dawnshadow",
  "Elorshin",
  "Elthaerin",
  "Embrinnar",
  "Erladden",
  "Evanara",
  "Faerondaerl",
  "Fathomwind",
  "Floshin",
  "Gaerth",
  "Galadrian",
  "Gwaelor",
  "Haevault",
  "Hawksong",
  "Ilbenalu",
  "Ildacer",
  "Ilnatar",
  "Irithyl",
  "Jaglathlar",
  "Keenblade",
  "Kenthyl",
  "Laelithar",
  "Lightshiver",
  "Mistlewood",
  "Moonbow",
  "Moonsilver",
  "Mournthorn",
  "Nathalan",
  "Nightmeadow",
  "Nimesin",
  "Olithir",
  "Orbryn",
  "Ortauré",
  "Phenthae",
  "Raedrimn",
  "Rhaevaern",
  "Rhothomir",
  "Selakiir",
  "Sharrith",
  "Shimmergloom",
  "Silverspear",
  "Starbreeze",
  "Starym",
  "Suldoun",
  "Sultaasar",
  "Tamuirn",
  "Tarnruth",
  "Teshurr",
  "Tlarith",
  "Ulongyr",
  "Vandree",
  "Waelvor",
  "Waelvaerel",
  "Wintermoon",
  "Yaeldrin",
  "Ysmyrr",
  "Zaurric",
  "Ardaneth",
  "Belargil",
  "Caerthil",
  "Doriathen",
  "Elenarwe",
  "Faelivrin",
  "Galathorn",
  "Halethion",
  "Ilmarethi",
  "Iolanthir",
  "Kaelendor",
  "Lindarael",
  "Lothirien",
  "Maethoril",
  "Nenharma",
  "Orethion",
  "Palanthir",
  "Quellarin",
  "Rhunathir",
  "Silmaeth",
  "Valanthor",
  "Arthanis",
  "Celebrindor",
  "Ecthelaine",
  "Finarphin",
  "Gilthoniel",
  "Ithildor",
  "Mithlondir",
  "Nimbrethil",
  "Taurenor",
  "Ainulindor",
  "Eldalindë",
  "Ilmarinë",
  "Lómelindi",
  "Nolmëron",
  "Oromëlin",
  "Tirionel",
  "Vinyarion",
  "Aelindor",
  "Briaranth",
  "Cyrilaeth",
  "Daelinor",
  "Eravyrn",
  "Faralinth",
  "Gwynaeth",
  "Hylarian",
  "Ilvaris",
  "Jhaelryn",
  "Kelorn",
  "Lyrandar",
  "Myrlinth",
  "Naerith",
  "Oakmere",
  "Phaeryth",
  "Rivaelin",
  "Sarenthil",
  "Thalanor",
  "Ulvarethe",
  "Vaelorin",
  "Wythaeren",
  "Yllandris",
  "Zephyrrin",
  "Aerendal",
  "Bellisarin",
  "Caladriel",
  "Dorneth",
  "Elvanshal",
  "Fenmarel",
  "Glyndaeren",
  "Haeloran",
  "Ithelion",
  "Jaerendel",
  "Kethrinor",
  "Laevarin",
  "Maerith",
  "Nivaleth",
  "Olindar",
  "Pelarion",
  "Quessandor",
  "Raelindel",
  "Syltharin",
  "Ulathaer",
  "Vharindel",
  "Wynvaren",
  "Ashenbough",
  "Autumnreach",
  "Birchwhisper",
  "Bloomhollow",
  "Brightwater",
  "Cedarsong",
  "Cloudmantle",
  "Dawnpetal",
  "Dewglimmer",
  "Duskmeadow",
  "Eveningstar",
  "Featherfall",
  "Fernshade",
  "Frostpetal",
  "Glimmerdew",
  "Goldenbough",
  "Greenhollow",
  "Hollowsong",
  "Ivythorn",
  "Larkspire",
  "Leafdancer",
  "Lightbough",
  "Lilyvale",
  "Mapleshade",
  "Meadowlark",
  "Mirrorlake",
  "Mistvale",
  "Moonbrook",
  "Moonglade",
  "Moonshadow",
  "Morningdew",
  "Mossgrove",
  "Oakwhisper",
  "Pinemist",
  "Rainsong",
  "Rivermist",
  "Rosethorn",
  "Rowanleaf",
  "Silverbrook",
  "Silvergrove",
  "Silverstream",
  "Skybloom",
  "Snowpetal",
  "Softstep",
  "Songbrook",
  "Springbough",
  "Starfall",
  "Starglow",
  "Starwatcher",
  "Stillwater",
  "Summerglen",
  "Sunbloom",
  "Sundew",
  "Sunleaf",
  "Swiftbrook",
  "Thistlecloud",
  "Thornglade",
  "Twilightvale",
  "Vinewhisper",
  "Wavecrest",
  "Whisperwind",
  "Wildrose",
  "Willowsong",
  "Windsong",
  "Winterbloom",
  "Wintersong",
  "Woodsinger",
  "Ashgrove",
  "Bellflower",
  "Blossomfall",
  "Brookshadow",
  "Cloudsong",
  "Dawnbloom",
  "Deepglade",
  "Dewdrop",
  "Driftleaf",
  "Elmshade",
  "Emberleaf",
  "Fairbrook",
  "Fallowmere",
  "Fawnbrook",
  "Feywind",
  "Gladesong",
  "Gleamwater",
  "Goldleaf",
  "Greenbriar",
  "Harpwind",
  "Hazelglen",
  "Heatherglow",
  "Highbough",
  "Hollyshade",
  "Lanternbloom",
  "Leafshadow",
  "Lightfeather",
  "Lindensong",
  "Mallowmere",
  "Moonpetal",
  "Moonriver",
  "Mosswhisper",
  "Nightbloom",
  "Nightsong",
  "Oakshadow",
  "Owlbrook",
  "Palegrove",
  "Petalwind",
  "Quietwater",
  "Rainleaf",
  "Reedwhisper",
  "Ripplemere",
  "Sagebrook",
  "Shadowleaf",
  "Shimmerleaf",
  "Silkwind",
  "Silverbough",
  "Silvermoon",
  "Skyglade",
  "Snowbough",
  "Starbough",
  "Starmantle",
  "Starriver",
  "Starwhisper",
  "Sunbough",
  "Sunglade",
  "Swanmere",
  "Sylvanmere",
  "Thornbloom",
  "Tidewhisper",
  "Treesong",
  "Vesperglade",
  "Wandermoon",
  "Willowshade",
  "Windpetal",
  "Wispwood",
  "Yewglade",
  "Amberleaf",
  "Ashenwind",
  "Bramblewood",
  "Brightleaf",
  "Briarmoon",
  "Copperleaf",
  "Dawnwhisper",
  "Dimglade",
  "Duskwhisper",
  "Elderbough",
  "Eveningsong",
  "Fairwind",
  "Fallowleaf",
  "Farsong",
  "Fernwhisper",
  "Firstlight",
  "Gildedleaf",
  "Greenwhisper",
  "Hartsong",
  "Hollowmoon",
  "Lakeshimmer",
  "Lightsong",
  "Longwhisper",
  "Lorebough",
  "Lunarbrook",
  "Mistfeather",
  "Moondancer",
  "Moonfall",
  "Morningbloom",
  "Nightwhisper",
  "Oakensong",
  "Palemoon",
  "Pearlbrook",
  "Raincloud",
  "Ravenshade",
  "Riverbough",
  "Rosewhisper",
  "Sablewood",
  "Shadowmoon",
  "Silvermist",
  "Skysong",
  "Snowwhisper",
  "Sorrowbough",
  "Starshade",
  "Stormbough",
  "Summerleaf",
  "Sunwhisper",
  "Swiftleaf",
  "Thornwhisper",
  "Twilightsong",
  "Valewhisper",
  "Wavesong",
  "Whitebough",
  "Wildbloom",
  "Windwhisper",
  "Winterleaf",
  "Wyrmglade",
  "Aelthas",
  "Ambrinar",
  "Arathel",
  "Ardeleth",
  "Belavar",
  "Caelmir",
  "Calendil",
  "Cirdanith",
  "Daerlith",
  "Doraniel",
  "Elessarin",
  "Erevanth",
  "Faenorin",
  "Galadhel",
  "Gilraeth",
  "Haldirion",
  "Ilthenor",
  "Ivalindë",
  "Kaelthas",
  "Lenwathil",
  "Lirathiel",
  "Mithrandor",
  "Naeranth",
  "Orodrin",
  "Sarnathil",
  "Tauremor",
  "Thaliondë",
  "Ulmarien",
  "Valaquen",
  "Vardaril",
  "Yavannil",
  "Ancalimon",
  "Faelivren",
  "Boldevar",
  "Celerond",
  "Daenthil",
  "Elarion",
  "Faelanor",
  "Galithrin",
  "Halamar",
  "Ilyrien",
  "Jandaril",
  "Kelvhanor",
  "Lorandil",
  "Mirethor",
  "Nethaniel",
  "Orlaeth",
  "Pellandor",
  "Quiravel",
  "Rillifane",
  "Saevoreth",
  "Thaeloran",
  "Uthariel",
  "Vilaeth",
  "Yrathiel",
  "Zeleth",
  "Arvandor",
  "Callaril",
  "Durinthal",
  "Elvanor",
  "Fyrandil",
  "Gelthorin",
  "Hethlindë",
  "Imrathil",
  "Jhaelis",
  "Kairendor",
  "Lathandiel",
  "Maelorin",
  "Nelmirion",
  "Oravaine",
  "Pyrrandel",
  "Raerithil",
  "Sylvandor",
  "Tavarion",
  "Uvalindor",
  "Vannaril",
  "Waelthorn",
  "Ysaraleth",
  "Aldenmir",
  "Bryndaril",
  "Coronath",
  "Dalavar",
  "Eiravenn",
  "Fianorel",
  "Gwaelanthir",
  "Hallarin",
  "Ilmatheir",
  "Kilivren",
  "Lysarion",
  "Morlaeth",
  "Nenyarin",
  "Oelanthir",
  "Pharindel",
  "Quilavar",
  "Rhaessor",
  "Sindarel",
  "Tessarane",
  "Ulyndar",
  "Vaelthir",
  "Wylandor",
  "Yllathir",
  "Zandeleth",
  "Craulnober",
  "Eveningfall",
  "Hlaerthiel",
  "Ilbaereth",
  "Iliathor",
  "Mistrivvin",
  "Nlossae",
  "Olortynnal",
  "Shaelarae",
  "Starbrow",
  "Tellynnan",
  "Uirthur",
  "Vyshaan",
  "Yaulanna",
  "Alcaerith",
  "Aloroth",
  "Dawnwillow",
  "Lanternmere",
  "Glimmerbough",
  "Heronwade"
 ]
}